export const en = {
  'enum.status.ACTIVE': 'Active',
  'enum.status.INACTIVE': 'Inactive',
  'enum.status.BLOCKED': 'Blocked',
  'enum.status.DISABLED': 'Disabled',
  'enum.status.LOST': 'Lost',
  'enum.status.PENDING': 'Pending',
  'enum.status.PAUSED': 'Paused',
  'enum.status.EXPIRED': 'Expired',
  'enum.status.CANCELLED': 'Cancelled',
  'enum.status.SUSPENDED': 'Suspended',
  'enum.status.REQUESTED': 'Requested',
  'enum.status.APPROVED': 'Approved',
  'enum.status.ENDED': 'Ended',
  'enum.status.REJECTED': 'Rejected',
  'enum.status.WITHDRAWN': 'Withdrawn',
  'enum.status.CANCELLATION_REQUESTED': 'Cancellation requested',
  'enum.status.PAID': 'Paid',
  'enum.status.FAILED': 'Failed',
  'enum.status.REFUNDED': 'Refunded',
  'enum.status.PARTIALLY_REFUNDED': 'Partially refunded',
  'enum.status.AUTHORIZED': 'Authorized',
  'enum.status.COMPLETED': 'Completed',
  'enum.status.PENDING_APPROVAL': 'Pending approval',
  'enum.status.BOOKED': 'Booked',
  'enum.status.ATTENDED': 'Attended',
  'enum.status.NO_SHOW': 'No show',
  'enum.status.WAITLISTED': 'Waitlisted',
  'enum.status.SCHEDULED': 'Scheduled',
  'enum.status.GRANTED': 'Granted',
  'enum.status.DENIED': 'Denied',
  'enum.status.VERIFIED': 'Verified',
  'enum.status.QUEUED': 'Queued',
  'enum.status.SENT': 'Sent',
  'enum.status.READ': 'Read',
  'enum.status.RUNNING': 'Running',
  'enum.status.DEAD': 'Dead',
  'enum.status.DRAFT': 'Draft',
  'enum.status.NOT_CONFIGURED': 'Not configured',
  'enum.status.CONNECTED': 'Connected',
  'enum.status.DISCONNECTED': 'Disconnected',
  'enum.status.DEGRADED': 'Degraded',
  'enum.status.ERROR': 'Error',
  'enum.status.INVALID_CREDENTIALS': 'Invalid credentials',
  'enum.status.RECEIVED': 'Received',
  'enum.status.PROCESSING': 'Processing',
  'enum.status.PROCESSED': 'Processed',
  'enum.status.IGNORED': 'Ignored',
  'enum.status.DONE': 'Done',
  'enum.status.OPEN': 'Open',
  'enum.status.CLOSED': 'Closed',
  'enum.status.SKIPPED': 'Skipped',
  'enum.status.REMOVED': 'Removed',
  'enum.denialReason.MEMBER_NOT_FOUND': 'Member not found',
  'enum.denialReason.MEMBER_BLOCKED': 'Member blocked',
  'enum.denialReason.MEMBERSHIP_NOT_FOUND': 'Membership not found',
  'enum.denialReason.MEMBERSHIP_PENDING': 'Membership pending',
  'enum.denialReason.MEMBERSHIP_EXPIRED': 'Membership expired',
  'enum.denialReason.MEMBERSHIP_PAUSED': 'Membership frozen',
  'enum.denialReason.MEMBERSHIP_CANCELLED': 'Membership cancelled',
  'enum.denialReason.MEMBERSHIP_SUSPENDED': 'Membership suspended',
  'enum.denialReason.NO_ACCESS_TODAY': 'No access today',
  'enum.denialReason.OUTSIDE_ALLOWED_HOURS': 'Outside allowed hours',
  'enum.denialReason.VISIT_LIMIT_REACHED': 'Visit limit reached',
  'enum.denialReason.INVALID_CREDENTIAL': 'Invalid credential',
  'enum.denialReason.INVALID_READER': 'Invalid reader',
  'enum.denialReason.ZONE_NOT_ALLOWED': 'Zone not allowed',
  'enum.denialReason.LOCATION_NOT_ALLOWED': 'Not valid at this branch',
  'enum.denialReason.ANTI_PASSBACK': 'Anti passback',
  'enum.denialReason.PROVIDER_ERROR': 'Provider error',
  'enum.denialReason.UNKNOWN': 'Unknown',
  'enum.direction.IN': 'In',
  'enum.direction.OUT': 'Out',
  'enum.direction.UNKNOWN': 'Unknown',
  'enum.readerKind.TURNSTILE': 'Turnstile',
  'enum.readerKind.DOOR': 'Door',
  'enum.readerKind.DESK': 'Desk',
  'enum.readerKind.LOCKER': 'Locker',
  'enum.readerKind.OTHER': 'Other',
  'enum.credentialType.RFID_CARD': 'RFID card',
  'enum.credentialType.QR_CODE': 'QR code',
  'enum.credentialType.WRISTBAND': 'Wristband',
  'enum.credentialType.PIN': 'PIN',
  'enum.credentialType.MOBILE': 'Mobile',
  'enum.paymentMethod.ONLINE': 'Online',
  'enum.paymentMethod.CASH': 'Cash',
  'enum.paymentMethod.CARD_TERMINAL': 'Card terminal',
  'enum.paymentMethod.BANK_TRANSFER': 'Bank transfer',
  'enum.integrationKind.PAYMENT': 'Payments',
  'enum.integrationKind.ACCESS_CONTROL': 'Access control',
  'enum.integrationKind.EMAIL': 'Email',
  'enum.integrationKind.STORAGE': 'Storage',
  'enum.integrationKind.SMS': 'Text messages',
  'enum.writeOffReason.EXPIRED': 'Expired',
  'enum.writeOffReason.DAMAGED': 'Damaged',
  'enum.writeOffReason.STAFF_USE': 'Staff use',
  'enum.writeOffReason.GIVEAWAY': 'Given away',
  'enum.writeOffReason.OTHER': 'Other',
  'enum.smsDelivery.DELIVERED': 'Delivered',
  'enum.smsDelivery.UNDELIVERED': 'Not delivered',
  'enum.smsDelivery.EXPIRED': 'Expired',
  'enum.smsDelivery.PENDING': 'Pending',
  'enum.smsDelivery.UNKNOWN': 'Unknown',
  'enum.smsTemplate.CLASS_CANCELLED': 'Class cancelled',
  'enum.smsTemplate.CLASS_CHANGED': 'Class changed',
  'enum.smsTemplate.MEMBERSHIP_EXPIRING': 'Membership ending',
  'enum.smsTemplate.MEMBER_INVITATION': 'Login invitation',
  'enum.smsTemplate.CAMPAIGN_OFFER': 'Offer',
  'enum.weekday.MON': 'Mon',
  'enum.weekday.TUE': 'Tue',
  'enum.weekday.WED': 'Wed',
  'enum.weekday.THU': 'Thu',
  'enum.weekday.FRI': 'Fri',
  'enum.weekday.SAT': 'Sat',
  'enum.weekday.SUN': 'Sun',
  'enum.role.PLATFORM_ADMIN': 'Platform admin',
  'enum.role.GYM_OWNER': 'Owner',
  'enum.role.GYM_ADMIN': 'Admin',
  'enum.role.STAFF': 'Staff',
  'enum.role.TRAINER': 'Trainer',
  'enum.role.MEMBER': 'Member',
  'enum.role.RECEPTIONIST': 'Reception',
  'enum.role.ACCOUNTANT': 'Accountant',
  'enum.role.MARKETING': 'Marketing',
  'enum.role.BARTENDER': 'Bartender',
  'enum.role.GYM_MANAGER': 'Gym general manager',
  'enum.role.BRANCH_MANAGER': 'Branch manager',
  'enum.role.DAY_MANAGER': 'Shift manager',
  'enum.role.MASSAGE_THERAPIST': 'Massage therapist',
  'enum.role.HR_MANAGER': 'HR manager',
  'enum.gender.MALE': 'Male',
  'enum.gender.FEMALE': 'Female',
  'enum.gender.OTHER': 'Other',
  'enum.gender.UNSPECIFIED': 'Unspecified',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.status.ACTIVE': 'აქტიური',
  'enum.status.INACTIVE': 'არააქტიური',
  'enum.status.BLOCKED': 'დაბლოკილი',
  'enum.status.DISABLED': 'გამორთული',
  'enum.status.LOST': 'დაკარგული',
  'enum.status.PENDING': 'მოლოდინში',
  'enum.status.PAUSED': 'დაპაუზებული',
  'enum.status.EXPIRED': 'ვადაგასული',
  'enum.status.CANCELLED': 'გაუქმებული',
  'enum.status.SUSPENDED': 'შეჩერებული',
  'enum.status.REQUESTED': 'მოთხოვნილი',
  'enum.status.APPROVED': 'დამტკიცებული',
  'enum.status.ENDED': 'დასრულებული',
  'enum.status.REJECTED': 'უარყოფილი',
  'enum.status.WITHDRAWN': 'გამოთხოვილი',
  'enum.status.CANCELLATION_REQUESTED': 'მოთხოვნილია გაუქმება',
  'enum.status.PAID': 'გადახდილი',
  'enum.status.FAILED': 'წარუმატებელი',
  'enum.status.REFUNDED': 'დაბრუნებული',
  'enum.status.PARTIALLY_REFUNDED': 'ნაწილობრივ დაბრუნებული',
  'enum.status.AUTHORIZED': 'ავტორიზებული',
  'enum.status.COMPLETED': 'დასრულებული',
  'enum.status.PENDING_APPROVAL': 'ელოდება დამტკიცებას',
  'enum.status.BOOKED': 'დაჯავშნილი',
  'enum.status.ATTENDED': 'დაესწრო',
  'enum.status.NO_SHOW': 'არ გამოცხადდა',
  'enum.status.WAITLISTED': 'მოლოდინის სიაში',
  'enum.status.SCHEDULED': 'დაგეგმილი',
  'enum.status.GRANTED': 'დაშვებული',
  'enum.status.DENIED': 'უარი',
  'enum.status.VERIFIED': 'დადასტურებული',
  'enum.status.QUEUED': 'რიგში',
  'enum.status.SENT': 'გაგზავნილი',
  'enum.status.READ': 'წაკითხული',
  'enum.status.RUNNING': 'მიმდინარე',
  'enum.status.DEAD': 'შეწყვეტილი',
  'enum.status.DRAFT': 'მონახაზი',
  'enum.status.NOT_CONFIGURED': 'არ არის დაყენებული',
  'enum.status.CONNECTED': 'დაკავშირებული',
  'enum.status.DISCONNECTED': 'გათიშული',
  'enum.status.DEGRADED': 'შეფერხებით',
  'enum.status.ERROR': 'შეცდომა',
  'enum.status.INVALID_CREDENTIALS': 'არასწორი მონაცემები',
  'enum.status.RECEIVED': 'მიღებული',
  'enum.status.PROCESSING': 'მუშავდება',
  'enum.status.PROCESSED': 'დამუშავებული',
  'enum.status.IGNORED': 'იგნორირებული',
  'enum.status.DONE': 'შესრულებული',
  'enum.status.OPEN': 'ღია',
  'enum.status.CLOSED': 'დახურული',
  'enum.status.SKIPPED': 'გამოტოვებული',
  'enum.status.REMOVED': 'წაშლილი',
  'enum.denialReason.MEMBER_NOT_FOUND': 'წევრი ვერ მოიძებნა',
  'enum.denialReason.MEMBER_BLOCKED': 'წევრი დაბლოკილია',
  'enum.denialReason.MEMBERSHIP_NOT_FOUND': 'აბონემენტი არ აქვს',
  'enum.denialReason.MEMBERSHIP_PENDING': 'აბონემენტი ელოდება გადახდას',
  'enum.denialReason.MEMBERSHIP_EXPIRED': 'აბონემენტს ვადა გაუვიდა',
  'enum.denialReason.MEMBERSHIP_PAUSED': 'აბონემენტი გაყინულია',
  'enum.denialReason.MEMBERSHIP_CANCELLED': 'აბონემენტი გაუქმებულია',
  'enum.denialReason.MEMBERSHIP_SUSPENDED': 'აბონემენტი შეჩერებულია',
  'enum.denialReason.NO_ACCESS_TODAY': 'დღეს დაშვება არ აქვს',
  'enum.denialReason.OUTSIDE_ALLOWED_HOURS': 'დაშვებული საათების გარეთ',
  'enum.denialReason.VISIT_LIMIT_REACHED': 'ვიზიტების ლიმიტი ამოწურულია',
  'enum.denialReason.INVALID_CREDENTIAL': 'ბარათი ან კოდი არ მოქმედებს',
  'enum.denialReason.INVALID_READER': 'უცნობი წამკითხველი',
  'enum.denialReason.ZONE_NOT_ALLOWED': 'ამ ზონაში დაშვება არ აქვს',
  'enum.denialReason.LOCATION_NOT_ALLOWED': 'ამ ფილიალში არ მოქმედებს',
  'enum.denialReason.ANTI_PASSBACK': 'განმეორებითი შესვლა (anti-passback)',
  'enum.denialReason.PROVIDER_ERROR': 'პროვაიდერის შეცდომა',
  'enum.denialReason.UNKNOWN': 'უცნობი',
  'enum.direction.IN': 'შესვლა',
  'enum.direction.OUT': 'გასვლა',
  'enum.direction.UNKNOWN': 'უცნობი',
  'enum.readerKind.TURNSTILE': 'ტურნიკეტი',
  'enum.readerKind.DOOR': 'კარი',
  'enum.readerKind.DESK': 'მიმღები',
  'enum.readerKind.LOCKER': 'კარადა',
  'enum.readerKind.OTHER': 'სხვა',
  'enum.credentialType.RFID_CARD': 'RFID ბარათი',
  'enum.credentialType.QR_CODE': 'QR კოდი',
  'enum.credentialType.WRISTBAND': 'სამაჯური',
  'enum.credentialType.PIN': 'PIN კოდი',
  'enum.credentialType.MOBILE': 'მობილური',
  'enum.paymentMethod.ONLINE': 'ონლაინ',
  'enum.paymentMethod.CASH': 'ნაღდი',
  'enum.paymentMethod.CARD_TERMINAL': 'ბარათის ტერმინალი',
  'enum.paymentMethod.BANK_TRANSFER': 'საბანკო გადარიცხვა',
  'enum.integrationKind.PAYMENT': 'გადახდები',
  'enum.integrationKind.ACCESS_CONTROL': 'დაშვების კონტროლი',
  'enum.integrationKind.EMAIL': 'ელფოსტა',
  'enum.integrationKind.STORAGE': 'ფაილების საცავი',
  'enum.integrationKind.SMS': 'SMS',
  'enum.writeOffReason.EXPIRED': 'ვადაგასული',
  'enum.writeOffReason.DAMAGED': 'დაზიანებული',
  'enum.writeOffReason.STAFF_USE': 'პერსონალის მოხმარება',
  'enum.writeOffReason.GIVEAWAY': 'საჩუქრად გაცემული',
  'enum.writeOffReason.OTHER': 'სხვა',
  'enum.smsDelivery.DELIVERED': 'მიწოდებულია',
  'enum.smsDelivery.UNDELIVERED': 'ვერ მიეწოდა',
  'enum.smsDelivery.EXPIRED': 'ვადა გაუვიდა',
  'enum.smsDelivery.PENDING': 'მოლოდინში',
  'enum.smsDelivery.UNKNOWN': 'უცნობია',
  'enum.smsTemplate.CLASS_CANCELLED': 'ვარჯიში გაუქმდა',
  'enum.smsTemplate.CLASS_CHANGED': 'ვარჯიში შეიცვალა',
  'enum.smsTemplate.MEMBERSHIP_EXPIRING': 'აბონემენტი მთავრდება',
  'enum.smsTemplate.MEMBER_INVITATION': 'შესვლის მოწვევა',
  'enum.smsTemplate.CAMPAIGN_OFFER': 'შეთავაზება',
  'enum.weekday.MON': 'ორშ',
  'enum.weekday.TUE': 'სამ',
  'enum.weekday.WED': 'ოთხ',
  'enum.weekday.THU': 'ხუთ',
  'enum.weekday.FRI': 'პარ',
  'enum.weekday.SAT': 'შაბ',
  'enum.weekday.SUN': 'კვ',
  'enum.role.PLATFORM_ADMIN': 'პლატფორმის ადმინისტრატორი',
  'enum.role.GYM_OWNER': 'მფლობელი',
  'enum.role.GYM_ADMIN': 'ადმინისტრატორი',
  'enum.role.STAFF': 'თანამშრომელი',
  'enum.role.TRAINER': 'ტრენერი',
  'enum.role.MEMBER': 'წევრი',
  'enum.role.RECEPTIONIST': 'მიმღები',
  'enum.role.ACCOUNTANT': 'ბუღალტერი',
  'enum.role.MARKETING': 'მარკეტინგი',
  'enum.role.BARTENDER': 'ბარმენი',
  'enum.role.GYM_MANAGER': 'დარბაზის გენერალური მენეჯერი',
  'enum.role.BRANCH_MANAGER': 'ფილიალის მენეჯერი',
  'enum.role.DAY_MANAGER': 'ცვლის მენეჯერი',
  'enum.role.MASSAGE_THERAPIST': 'მასაჟისტი',
  'enum.role.HR_MANAGER': 'HR მენეჯერი',
  'enum.gender.MALE': 'მამრობითი',
  'enum.gender.FEMALE': 'მდედრობითი',
  'enum.gender.OTHER': 'სხვა',
  'enum.gender.UNSPECIFIED': 'არ არის მითითებული',
};
